/**
 * MediaSource MP3 streaming is unreliable on iOS WebKit (Safari, Chrome/CriOS,
 * Firefox/FxiOS on iPhone/iPad) and most mobile browsers.
 * Blob-based playback on a gesture-unlocked audio element works consistently.
 */
export function shouldUseBlobTtsPlayback(): boolean {
  if (typeof window === 'undefined') return false;

  if (typeof MediaSource === 'undefined' || !MediaSource.isTypeSupported('audio/mpeg')) {
    return true;
  }

  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod|Android|CriOS|FxiOS|EdgiOS/i.test(ua)) {
    return true;
  }

  return false;
}
